exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "[data-v-bcb3acf6] .pt-switch{padding-top:20px}[data-v-bcb3acf6] .currency-prepend-outer-icon>.v-input__control>.v-input__slot>.v-input__prepend-inner>.v-input__icon--prepend-inner>.v-icon{background-color:#fff!important;position:absolute;padding:18px 5px;margin-right:14px}", "", {"version":3,"sources":["/vercel/path0/src/pages/Product.vue"],"names":[],"mappings":"AACA,6BACE,gBAAkB,CACnB,AACD,8IACE,gCAAmC,AACnC,kBAAmB,AACnB,iBAAkB,AAClB,iBAAmB,CACpB","file":"Product.vue","sourcesContent":["\n[data-v-bcb3acf6] .pt-switch {\n  padding-top: 20px;\n}\n[data-v-bcb3acf6] .currency-prepend-outer-icon>.v-input__control>.v-input__slot>.v-input__prepend-inner>.v-input__icon--prepend-inner>.v-icon {\n  background-color: white !important;\n  position: absolute;\n  padding: 18px 5px;\n  margin-right: 14px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bcb3acf6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Product.vue
// module id = 617
// module chunks = 10